module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_8.e4bc2e94.png";